import { sendEvent } from '@core/track';

// 六国落地页埋点数据
const commonTraceMap: Record<string, string> = {
	firstName: 'en_adPage0802_NameInput',
	lastName: 'en_adPage0802_LastNameInput',
	gradeCode: 'en_adPage0802_Grade',
	subjectCode: 'en_adPage0802_SubjectSelect',
	areaCode: 'en_adPage0802_AreaCodeSelect',
	phone: 'en_adPage0802_PhoneInput',
	email: 'en_adPage0802_Email',
	agreement: 'en_adPage0802_Agreement',
	submit: 'en_adPage0802_ClickSubmit',
	result: 'en_adPage0802_SubmitResult',
	footerBtnClick: 'en_adPage0802_ClickFooterButton',
	view: 'en_adPage0802_PageView',
};
// 六国落地页英国二跳页埋点数据
const stepTraceMap: Record<string, string> = {
	firstName: 'EAF_5f91b4c7882a9c86',
	lastName: 'EAF_257ce06aa1a2673a',
	gradeCode: 'EAF_cb75227982803c58',
	subjectCode: 'EAF_34c2ac31eba51705',
	areaCode: 'EAF_028df9ebb7e24d7c',
	phone: 'EAF_b9209c07730b85ab',
	agreement: 'EAF_0fff582d120d0c21',
	next: 'EAF_dbf095b26a95b2a5',
	submit: 'EAF_10836bf09a655945',
	result: 'EAF_caac0e84e25b57d8',
	footerBtnClick: 'EAF_541474edcb44fd4c',
	view: 'EAF_1da9d09b96403fc5',
};
// 六国落地页英国动态页埋点数据
const tintTraceMap: Record<string, string> = {
	firstName: 'EAF_613dfddb8f6d84b8',
	lastName: 'EAF_3a30bc70f8b633a6',
	gradeCode: 'EAF_5d55de987d99f51b',
	subjectCode: 'EAF_2213e25e5db7451f',
	areaCode: 'EAF_947f0dc648d0043b',
	phone: 'EAF_c4633e9dc4cf4c9e',
	agreement: 'EAF_d94737339d935db3',
	submit: 'EAF_a2deb13dad93f670',
	result: 'EAF_3ef5c03ac35f2c07',
	footerBtnClick: 'EAF_db5eff37f11fdf89',
	view: 'EAF_1459eb2aceecab14',	// 英国落地页动效版本访问
	showPromptModal: 'EAF_43d52e8411a5dd39', // 英国落地页动效版本挽留弹窗展示
	clickPromptBtn: 'EAF_46d5741cb69064e6', // 英国落地页动效版本点击挽留弹窗按钮
}

const trace = (traceMap: Record<string, string>, label: string, value: any) => {
	if (!label || !traceMap[label]) return;
	sendEvent({
		eventId: traceMap[label],
		eventParam: value ? {
			[label.toLowerCase()]: value,
		} : {},
	})
}

export default function (label: string, value?: any) {
	const pathname = window.location.pathname;
	let traceMap = commonTraceMap;
	if (pathname === '/uk/apply-tutor/step') {
		traceMap = stepTraceMap;
	}
	if (pathname === '/uk/apply-tutor/tint') {
		traceMap = tintTraceMap;
	}
	trace(traceMap, label, value);
}
